import { useEffect, useState } from "react";
import React from 'react';

const StickyHeader = ({ children }) => {
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      setIsSticky(scrollTop > 130);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className={`sticky-header ${isSticky ? "active" : ""}`}>
      {children}
    </div>
  );
};

export default StickyHeader;
